exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results {\n  list-style: none;\n  padding: 0;\n  margin: 0 auto 5rem;\n}\n.search-results li + li {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 0.1rem solid #CFCFCF;\n}\n.sector-post-feed {\n  max-width: 78rem;\n  margin: 0 auto;\n}", ""]);

// exports
